import { xor } from 'lodash';
import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { selectImpactedEntities } from '../../modules/changeImpacts.js';

const mapStateToProps = (state, ownProps) => ({
  impactedExternalEntities: selectImpactedEntities(ownProps.id)(state)
    .impactedExternalEntities,
});

ExternalEntitiesFilter.defaultProps = {
  selectedImpactedExternalEntitiesIds: [],
};

function ExternalEntitiesFilter({
  impactedExternalEntities,
  selectedImpactedExternalEntitiesIds,
  navigateAction,
}) {
  const selectedCount = selectedImpactedExternalEntitiesIds.length;

  const handleSelect = useCallback(
    (entityId) =>
      navigateAction({
        impactedExternalEntitiesIds: entityId
          ? xor(selectedImpactedExternalEntitiesIds, [entityId])
          : [],
      }),
    [selectedImpactedExternalEntitiesIds]
  );

  const renderMenuItem = useCallback(
    (entity) => (
      <React.Fragment key={entity.id}>
        <MenuItem
          active={selectedImpactedExternalEntitiesIds.includes(entity.id)}
          eventKey={entity.id}
          onSelect={handleSelect}
        >
          {entity.name}
        </MenuItem>
      </React.Fragment>
    ),
    [selectedImpactedExternalEntitiesIds]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">
        External People, Group, Company, Vendor
      </div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="entities-filter"
          className="btn-block"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          <MenuItem divider />
          {impactedExternalEntities.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default connect(mapStateToProps)(ExternalEntitiesFilter);
